"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleFooter = exports.ArticleHeader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ ARTICLE > ARTICLE ] ##################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. ARTICLE HEADER .........................................................


var ArticleHeader = _styledComponents["default"].header.withConfig({
  displayName: "indexstyle__ArticleHeader",
  componentId: "p3nsc6-0"
})(["width:50%;text-align:left!important;padding-top:var(--gutter-medium);padding-left:var(--gutter-large);padding-right:var(--gutter-large);h2{margin:0 0 var(--gutter-small) 0;}p{", "}@media ", "{width:100%;padding:var(--gutter);};@media ", "{width:80%;padding-left:var(--gutter-medium);padding-right:var(--gutter-medium);};@media ", "{width:60%;padding-left:10%;padding-right:10%;};@media ", "{padding-left:15%;padding-right:15%;};"], (0, _architectMixins._mixin_font_size)('medium'), _architectMixins._mixin_device.s, _architectMixins._mixin_device.m, _architectMixins._mixin_device.l, _architectMixins._mixin_device.xl); // 3.1. END ....................................................................
// 3.3. ARTICLE FOOTER .........................................................


exports.ArticleHeader = ArticleHeader;

var ArticleFooter = _styledComponents["default"].footer.withConfig({
  displayName: "indexstyle__ArticleFooter",
  componentId: "p3nsc6-1"
})([""]); // 3.3. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.ArticleFooter = ArticleFooter;